<script setup lang="ts">
import ProductCardList from '@/widgets/productCardList/index';
import UIButton from '@/shared/ui/Button/index';
import { useProducts } from '@/entities/products/composables/useProducts';

const { t } = useI18n();
const localePath = useLocalePath();
const isMobile = inject('isMobile');
const { products } = await useProducts({ popular: true, page_size: 8 }, 'popular');
</script>

<template>
  <div class="popular-products-section" :class="{ _mobile: isMobile }">
    <h3 class="popular-products-section__title">{{ t('popularProducts') }}</h3>
    <div class="popular-products-section__content">
      <div class="popular-products-section__list">
        <ProductCardList :products="products" gap="20px" column-width="23%" />
      </div>
      <div class="popular-products-section__button-wrapper">
        <UIButton
          :text="t('moreProducts')"
          light-orange
          :aria-label="t('moreProducts')"
          :to="localePath('popular')"
        />
      </div>
    </div>
  </div>
</template>

<style lang="less">
.popular-products-section {
  .container-d();
  .flex-column(@size-x7);

  &__title {
    .h2();
  }

  &__content {
    .flex-column(@size-x10);
  }

  &__button-wrapper {
    max-width: 165px;
    margin: 0 auto;
  }

  &._mobile {
    .container-m();

    gap: @size-x6;

    &__content {
      .flex-column(@size-x5);
    }
  }
}
</style>
